// Long-text fields share the same surface as short-text - Discord's
// modal text component carries the style flag, the builder doesn't need
// extra config from the studio.

export function LongTextConfig(): JSX.Element | null {
  return null;
}
